import TYPES from '../mutation_types';

// initial state
const state = {
    userId: -1,
    accountEmail: null,
    userName: null,
    permissionsId: 1,
    permissionsName: null
};

// getters
const getters = {
    getUserInfo: state => {
        return {
            userId: state.userId,
            accountEmail: state.accountEmail,
            userName: state.userName,
            permissionsId: state.permissionsId,
            permissionsName: state.permissionsName
        };
    },
};

// actions
const actions = {
    init({ commit }, userInfo) {
        commit(TYPES.INIT_USER_INFO, userInfo);
    }
};

// mutations
const mutations = {
    [TYPES.INIT_USER_INFO](state, userInfo) {
        if (userInfo) {
            try {
                state.userId = userInfo.userId;
                state.accountEmail = userInfo.accountEmail;
                state.userName = userInfo.userName;
                state.permissionsId = userInfo.permissionsId;
                state.permissionsName = userInfo.permissionsName;
            } catch (err) {
                console.error(err);
            }
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/user.js